import React from "react";
import logo from "@images/shared/VoxelLogo.png";

const CMSHome = () => {
  return <img src={logo} alt="Voxel Architexts Logo" className="image"></img>;
};

export default CMSHome;
